import { SiwViemMessage } from "@feelsgoodman/siwviem";
import { getCsrfToken, signIn, useSession } from "next-auth/react";
import { useAccount, useSignMessage } from "wagmi";

import { Button } from "./Button";

function Login() {
  const { signMessageAsync } = useSignMessage();

  const { address, chain } = useAccount();

  const { data: session, status } = useSession();

  const handleLogin = async () => {
    try {
      const callbackUrl = window.location.href;
      const message = new SiwViemMessage({
        domain: window.location.host,
        address: address,
        statement: "Sign in to Speedtracer with your wallet",
        uri: window.location.origin,
        version: "1",
        chainId: chain?.id,
        nonce: await getCsrfToken(),
      });
      const signature = await signMessageAsync({
        account: address,
        message: message.prepareMessage(),
      });
      signIn("credentials", {
        message: JSON.stringify(message),
        redirect: false,
        signature,
        callbackUrl,
      });
    } catch (error) {
      // window.alert(error);
    }
  };

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <Button
        className="text-center justify-center w-full"
        onClick={(e) => {
          e.preventDefault();

          handleLogin();
        }}
      >
        Sign-in
      </Button>
    </div>
  );
}

export async function getServerSideProps(context: any) {
  return {
    props: {
      csrfToken: await getCsrfToken(context),
    },
  };
}

export default Login;
